<script lang="ts">
  import { onMount } from "svelte";
  import { isLoading } from "./store";
  import MainContent from "./MainContent.svelte";
  import { fade } from 'svelte/transition';

  let mainContentVisible = false;
  let mainContentLoaded = false;

  onMount(async () => {
    isLoading.set(true);

    const contentPromise = new Promise(resolve => {
      setTimeout(() => {
        mainContentLoaded = true;
        resolve(true);
      }, 0);
    });

    await Promise.all([
      contentPromise,
      new Promise(resolve => setTimeout(() => {
        resolve();
      }, 3000))
    ]);

    isLoading.set(false);
    mainContentVisible = true;
  });
</script>

{#if $isLoading}
  <div class="spinner-container">
    <div class="spinner">
      <div class="double-bounce1"></div>
      <div class="double-bounce2"></div>
    </div>
  </div>
{/if}

{#if mainContentLoaded}
  <div class:visible={mainContentVisible} transition:fade={{ duration: 300 }}>
    <MainContent />
  </div>
{/if}

<style>
  .spinner-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #2B2B28;
    z-index: 9999;
  }

  .spinner {
    width: 60px;
    height: 60px;
    position: relative;
  }

  .double-bounce1, .double-bounce2 {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #fff;
    opacity: 0.6;
    position: absolute;
    top: 0;
    left: 0;
    animation: double-bounce 2.0s infinite ease-in-out;
  }

  .double-bounce2 {
    animation-delay: -1.0s;
  }

  @keyframes double-bounce {
    0%, 100% {
      transform: scale(0);
    }
    50% {
      transform: scale(1);
    }
  }

  .visible {
    opacity: 1;
    transition: opacity 0.3s ease;
  }
</style>
